import React from 'react';
import cx from 'classnames';
import InputForm from '../InputForm';
import { MAXIMUM_PERCENT, MINIMUM_PERCENT, PERCENT_UNIT } from '../../../constants/service/common/commonConstants';

const InputPercentForm = (props) => {
  const {
    form,
    name,
    label,
    isEditable,
    initialValue,
    onChange,
    rules,
    precision = 1,
    max = MAXIMUM_PERCENT,
    min = MINIMUM_PERCENT,
    step = PERCENT_UNIT,
    className,
    ...res
  } = props;

  return (
    <InputForm
      className={cx('input-percent-form', className)}
      label={label}
      form={form}
      name={name}
      type="number"
      isEditable={isEditable}
      max={max}
      min={min}
      step={step}
      formatter={(value) => `${value}%`}
      parser={(value) => value.replace('%', '')}
      unit="%"
      precision={precision}
      rules={rules}
      initialValue={initialValue}
      onChange={(value) => {
        if (typeof value === 'number' && value >= min && value <= max) {
          onChange?.(value);
        }
      }}
      {...res}
    />
  );
};

export default InputPercentForm;
